import Vue from "vue";

const CONFIG_API = {
    hotPort: "/pc/port/hot-port",
    harborDetail:"/pc/port/filter",
    productList:"/pc/product/cruise-list",
    portList:'/pc/port/list'
}

export function getHotHarbor() {
    return Vue.$axios.$post(CONFIG_API.hotPort);
}

export function getHarborDetail(data) {
    return Vue.$axios.$post(CONFIG_API.harborDetail, { data } )
}

export function getProductList(data) {
    return Vue.$axios.$post(CONFIG_API.productList, { data })
}

export function getPortList(){
    return Vue.$axios.$post(CONFIG_API.portList)
}